type BuildAuthorNameInput = {
	firstname: string;
	lastname: string;
};

export function buildAuthorName(author: BuildAuthorNameInput) {
	return [author.firstname, author.lastname]
		.map((part) => part.trim())
		.filter((part) => !!part)
		.join(' ');
}
